import React, { Component } from "react";
import { compose, graphql } from "react-apollo";

import ClientForm from "./ClientForm";
import Queries from "../../queries/queries2";
import Spinner from "../../elements/Spinner/Spinner";
import _ from "lodash";
import { getTiersXtraData, setTiersXtraData } from "../../tools/tiersExtraData";

class ClientEdit extends Component {
  constructor(props) {
    super(props);
    if (props.getClientQuery.tiers) {
      this.state = this.getStateObject(props.getClientQuery.tiers);
    } else {
      this.state = { client: null };
    }
    props.getClientQuery.refetch();
  }
  getStateObject({
    id,
    addresses,
    company,
    currency,
    iban,
    name,
    swift,
    website,
    client,
    group,
    xtraData
  }) {
    let contacts = [];
    client.contacts.map(contact => {
      const newContact = {
        id: contact.id,
        email: contact.email,
        job: contact.job,
        name: contact.name,
        telFixe: contact.telFixe,
        telMobile: contact.telMobile
      };
      contacts.push(newContact);
      return newContact;
    });

    // console.log("45 - client=", client);
    return {
      client: {
        id,
        address: addresses && addresses.length > 0 ? addresses[0].address : "",
        addressId:
          addresses && addresses.length > 0 ? addresses[0].id : undefined,
        country:
          addresses && addresses.length > 0 && addresses[0].country
            ? addresses[0].country.id
            : null,
        countryLabel: addresses && addresses.length > 0 && addresses[0].country
          ? addresses[0].country.label
          : null,
        company: company ? company.id : "",
        currency: currency ? currency.id : "",
        iban: iban ? iban : "",
        name,
        swift,
        website,
        contacts,
        group,
        taxableValue: xtraData ? getTiersXtraData(xtraData).taxable : null,
        externalCodeValue: xtraData ? getTiersXtraData(xtraData).externalCode : null,
        escomptePercentValue: xtraData ? getTiersXtraData(xtraData).escomptePercent : null,
        codeAPE: client.codeAPE,
        tax1: client.defaultTax1,
        tax2: client.defaultTax2,
        taxIdemCompany: client.taxIdemCompany,
        defaultTermDelaisPaiement: client.defaultTermDelaisPaiement,
        defaultTermNetsFinDeMois: client.defaultTermNetsFinDeMois,
        language: client.language ? client.language.id : "",
        dateLanguage: client.dateLanguage ? client.dateLanguage.id : (client.language ? client.language.id : ""),
        numeroTVA: client.numeroTVA,
        relanceAuto: client.relanceAuto,
        siret: client.siret ? client.siret : "",
        collaboratorRespCom: client.collaboratorRespCom
        
      }
    };
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.getClientQuery.tiers &&
      prevProps.getClientQuery.tiers !== this.props.getClientQuery.tiers
    ) {
      this.setState(this.getStateObject(this.props.getClientQuery.tiers));
    }
  }
  createUpdateAndDeleteContacts = async values => {
    const formerContactList = this.props.getClientQuery.tiers.client.contacts;
    let newContactList = [];
    await Promise.all(
      values.contacts.map(async contact => {
        const formerContact = _.find(formerContactList, { id: contact.id });
        if (!formerContact) {
          const c = {
            ...contact,
            companyId: this.props.companyDefaultInfos.company.id,
            clientId: this.props.getClientQuery.tiers.client.id
          };
          const contact_created = await this.props.createContact({
            variables: c
          });

          await newContactList.push(contact_created.data.createContact);
        } else if (formerContact !== contact) {
          const c = {
            ...contact,
            companyId: this.props.companyDefaultInfos.company.id
          };
          const contact_updated = await this.props.updateContact({
            variables: c
          });

          await newContactList.push(contact_updated.data.updateContact);
        }
      })
    );
    const deleteContacts = (newContactList, formerContactList) => {
      if (newContactList.length !== formerContactList.length) {
        var ids = _.differenceWith(
          _.map(formerContactList, "id"),
          _.map(newContactList, "id"),
          _.isEqual
        );
        ids.map(id => this.props.deleteContact({ variables: { id } }));
      }
    };
    await deleteContacts(newContactList, formerContactList);
    return newContactList;
  };
  onSubmit = async values => {
    if (values && values.name === "") return;

    const newContactList = await this.createUpdateAndDeleteContacts(values);
    const submit = (newContactList, values) => {
      if (values.contacts.length === newContactList.length) {
        this.props.onSubmit(values);
      }
    };
    values["collaboratorRespComId"] =
      values.tiersRespCom &&
      values.tiersRespCom.tiers &&
      values.tiersRespCom.tiers.collaborator &&
      values.tiersRespCom.tiers.collaborator.id;

    values["disconnectCollaboratorRespComId"] =
      !!!values["collaboratorRespComId"] &&
      !!this.state.client.collaboratorRespCom;
    values["connectCollaboratorRespComId"] = !!values["collaboratorRespComId"];

    values["clientId"] = this.props.getClientQuery.tiers.client.id;

    values["disconnectTax1"] = !!(!values.tax1 && this.state.client.tax1);
    values["connectTax1"] = !!(
      values.tax1 && values.tax1 !== this.state.client.tax1
    );
    values["disconnectTax2"] = !!(!values.tax2 && this.state.client.tax2);
    values["connectTax2"] = !!(
      values.tax2 && values.tax2 !== this.state.client.tax2
    );
    if (
      !this.state.client.taxIdem &&
      values.taxIdemCompany &&
      !!this.state.client.tax1 &&
      !!this.state.client.tax2
    ) {
      values["disconnectTax1"] = true;
      values["disconnectTax2"] = true;
    }
    if (values.taxIdemCompany) {
      values["connectTax1"] = !!values.tax1;
      values["connectTax2"] = !!values.tax2;
    }

    // xtraData
    values["xtraData"] = setTiersXtraData(this.props.xtraData, values.taxableValue, values.externalCodeValue, values.escomptePercentValue)
   
    submit(newContactList, values);
  };

  deleteClient = async () => {
    console.log(">> onDelete...", this.props.getClientQuery.tiers);

    const deleted = await this.props.deleteTiers_Client({
      variables: this.props.getClientQuery.tiers
    });

    return deleted;
  };

  render() {
    const companyId =
      this.props.getClientQuery.tiers &&
      this.props.getClientQuery.tiers.company.id;

    if (this.state.client) {
      // console.log("205 - clientEdit", this.state.client);
      return (
        <ClientForm
          sendNotification={this.props.sendNotification}
          client={this.state.client}
          cancel={this.props.cancel}
          inSideModal={this.props.inSideModal}
          companyDefaultInfos={this.props.companyDefaultInfos}
          companyId={companyId}
          onSubmit={values => this.onSubmit(values)}
          deleteClient={this.deleteClient}
          handleMinimizeSidebar={this.props.handleMinimizeSidebar}
          checkDelete={this.props.checkOnlyDeleteTiers_Client}
        />
      );
    }
    return <Spinner size="lg" fullScreen />;
  }
}

export default compose(
  graphql(Queries.GET_CLIENT, { name: "getClientQuery" }),
  graphql(Queries.CREATE_CLIENT_CONTACT_MUTATION, { name: "createContact" }),
  graphql(Queries.UPDATE_CONTACT_MUTATION, { name: "updateContact" }),
  graphql(Queries.DELETE_CONTACT_MUTATION, { name: "deleteContact" }),
  graphql(Queries.DELETE_TIERS_MUTATION, { name: "deleteTiers_Client" }),
  graphql(Queries.CHECK_ONLY_DELETE_TIERS, { name: "checkOnlyDeleteTiers_Client" })
)(ClientEdit);
